import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import MainHeader from '../../components/MainHeader';
import Footer from '../../components/Footer';
import './MainScreens.css';

export default function ProfileScreen() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  async function handleLogout() {
    if (window.confirm('Are you sure you want to logout?')) {
      await logout();
      navigate('/login');
    }
  }

  return (
    <div className="main-screen">
      <MainHeader title="Profile" showBack={true} backPath="/home" />

      <main className="screen-main">
        <div className="profile-container">
          <div className="profile-card">
            <div className="profile-avatar">
              {user?.avatar ? (
                <img src={user.avatar} alt={user.displayName} />
              ) : (
                <div className="avatar-placeholder">
                  {user?.firstName?.[0]}{user?.lastName?.[0]}
                </div>
              )}
            </div>
            <h2 className="profile-name">{user?.displayName}</h2>
            <p className="profile-email">{user?.email}</p>
          </div>

          <div className="profile-section">
            <h3 className="section-title">Account</h3>
            <div className="profile-info">
              <div className="info-row">
                <span className="info-label">Account Type</span>
                <span className="info-value">{user?.accountType || 'Solo'}</span>
              </div>
              {user?.partner && (
                <div className="info-row">
                  <span className="info-label">Partner</span>
                  <span className="info-value">{user.partnerName}</span>
                </div>
              )}
            </div>
          </div>

          <div className="profile-section">
            <h3 className="section-title">Actions</h3>
            <button onClick={() => navigate('/subscription')} className="action-btn-full">
              💎 Manage Subscription
            </button>
            <button onClick={() => navigate('/couple-link')} className="action-btn-full">
              💑 {user?.partner ? 'Manage Partner' : 'Link Partner'}
            </button>
            <button onClick={() => navigate('/analytics')} className="action-btn-full">
              📊 View Analytics
            </button>
          </div>

          <button onClick={handleLogout} className="btn btn-danger">
            Logout
          </button>

          <p className="version-text">Hangrily v1.1.3</p>
        </div>
      </main>

      <Footer />
    </div>
  );
}
